enum BusinessBranchNonProfitCharityStatus {
    No = 0,
    Yes = 1,
    All = 2,
}

export default BusinessBranchNonProfitCharityStatus
